import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setTradeIn } from '../actions'
import Contact from './Contact'

const mapStateToProps = state => ({
  wizards: state.wizards,
  tradeIn: state.tradeIn,
  campaign: state.configuration.campaign,
  privacyPolicy: state.configuration.privacyPolicy,
  applicationOptions: state.configuration.applicationOptions,
  currentPricingPolicy: state.configuration.currentPricingPolicy,
  automaticValidationSetting: state.configuration.automaticValidationSetting
})

const mapDispatchToProps = {
  setWizards,
  setTradeIn
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact)
